import React, { useState, useEffect, useRef } from 'react';

//************** Funciones de Conexion **************/
import { getMenus } from '../../../API/Menu/MenuRequests';

//************** Componentes generales **************/
import Card from '../../../Components/Card/Card';
import Icon from '../../../Components/Icon/Icon';
import Loader from '../../../Components/Loader/Loader';
// import IconApp from '../../../../Components/Icon/IconApp';
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';

//************** Importacion de Modal **************/
// import ModalMenu from './ModalMenuScreeen.js/ModalMenu';

//************** Importacion de Componentes de PrimeReacts **************/
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';

import { putActividadMenu } from "../../../API/Menu/MenuRequests"
import ModalMenu from './EditarMenu/EditarMenu';

const MenuScreen = () => {

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const toast = useRef(null);
  const [checked, setChecked] = useState(false)

  const [menuDialog, setMenuDialog] = useState(false);
  const [IdMenu, setIdMenu] = useState(0)

  const openDialog = (Id) => {
    setMenuDialog(true)
    setIdMenu(Id)
  }

  const hideDialog = () => {
    setMenuDialog(false)
    getListadoMenu()
  }

  let aspectoBoton = [
    {
      Id: 1,
      Nombre: "Nuevo",
      Icono: "pi pi-plus",
      className: "p-button-Primary mr-2"
    },

    {
      Id: 2,
      Nombre: "",
      Icono: "pi pi-pencil",
      className: "p-button-rounded p-button-info p-button-text"
    }
  ]

  const onChangeCheck = async (activo, IdMenu, e) => {
    console.log(activo, IdMenu, e)
    let activosMenu = {
      Menu: activo,
      Activo: e,
      IdMenu: IdMenu
    }


    const result = await putActividadMenu(activosMenu)
    const temporal = result.map((item) => {
      console.log(item)
      if (item.id === IdMenu) {
        item.ActivoAPP = true
      }
      return item
    })
    setData(temporal)

    // setData(result)


  }



  const botones = (rowData) => {
    // console.log(rowData)
    return (
      <div className='col-12 d-flex' style={{ textAlign: 'center', height: 28, marginTop: -6 }}>
        <Button icon='pi pi-pencil' onClick={() => openDialog(rowData.IdMenu)}
          className='p-button-rounded p-button-info p-button-text' />
      </div>

    )
  }

  const check = (rowData) => {
    return <Checkbox onChange={(e) => setChecked(e.value)} checked={rowData.ActivoAPP} style={{ marginTop: -1 }} ></Checkbox>
  }


  const table = {
    Data: data,
    Columns: [
      {
        // IdMenu: 1,
        field: 'IdMenu',
        header: 'IdMenu',
        className: 'colum-width-Xsmall',
        body: (rowData) => rowData.IdMenu,
      },
      {
        // Menu: 'Menu',
        field: 'Menu',
        header: 'Menu',
        className: 'medium',
        body: (rowData) => rowData.Menu,
      },
      {
        // Menu: 'Menu',
        field: 'Titulo',
        header: 'Titulo',
        className: 'medium',
        body: (rowData) => rowData.Titulo,
      },
      {
        // Menu: 'Menu',
        field: 'Title',
        header: 'Title',
        className: 'medium',
        body: (rowData) => rowData.Title,
      },
      {
        // Icon
        field: 'Icon',
        header: 'Icon Webs',
        className: 'colum-width-small',
        body: (rowData) => <Icon icon={rowData.Icon ? rowData.Icon : 'a'} />,
        align: 'center',
        Format: 'Icon'
      },
      {
        // IconApp
        field: 'IconApp',
        header: 'IconApp',
        className: 'colum-width-small',
        body: (rowData) => <Icon icon={rowData.IconApp ? rowData.IconApp : 'a'} />,
        // align: 'center',
        Format: 'Icon'
      },
      {
        // URL
        field: 'URL',
        header: 'URL',
        className: 'colum-width-XXlarge',
        body: (rowData) => rowData.URL,
        flex: 1,
      },
      {
        // Contenedor
        field: 'Contenedor',
        header: 'Contenedor',
        className: 'medium',
        body: (rowData) => rowData.Contenedor,

      },

      {
        // MenuWeb
        field: 'MenuWeb',
        header: 'Activo Web',
        className: 'Xsmall',
        align: 'center',
        Format: "Checkbox",
        body: (rowData) => <Checkbox onChange={(e) => onChangeCheck(1, rowData.IdMenu, e.checked)} style={{ marginBottom: 5 }} checked={rowData.MenuWeb} />,

      },
      {
        // ActivoApp
        field: 'ActivoApp',
        header: 'Activo App',
        className: 'Xsmall',
        // align: 'center',
        Format: "Checkbox",
        body: (rowData) => <Checkbox onChange={(e) => onChangeCheck(2, rowData.IdMenu, e.checked)} style={{ marginBottom: 5 }} checked={rowData.ActivoApp} />,

      },
      {
        header: '',
        className: 'Xsmall',
        body: (rowData) => rowData?.IdMenu ? botones(rowData) : null,
        Format: "Template",
        frozen: true,
        alignFrozen: 'right',
      }
    ],
    key: 'IdMenu',
    // scrollHeight: '100%',

  }



  const getListadoMenu = async () => {
    setLoading(true);
    const result = await getMenus();
    setData(result)
    setLoading(false);
  }

  useEffect(() => {
    getListadoMenu();
    window.document.title = 'PPF • IT Menu';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{ width: '99%' }}>
      <Loader loading={loading} />
      <Toast position="bottom-right" ref={toast} />
      <Card
        titulo={
          <div className="d-flex my-2" style={{ alignItems: 'center' }}>
            <h3 className="mx-3">Menu</h3>
            <Button className=" mx-2" icon="ri-restart-line" loading={loading} onClick={getListadoMenu} />
            <Button icon='pi pi-plus' onClick={() => openDialog(0)} severity='success' />
          </div>}
        contenido={
          <div className='pt-5' style={{ height: '90vh' }}>
            <AgGrid table={table} />
          </div>
        }
      />
      <ModalMenu
        menuDialog={menuDialog}
        setMenuDialog={setMenuDialog}
        hideDialog={hideDialog}
        IdMenu={IdMenu}
      />
    </div>
  )
}

export default MenuScreen;